import { KdsInfoIcon, KdsLink, KdsText } from "@kazaar-platform/design-system";
import { RiCheckboxCircleFill } from "@remixicon/react";
import { useTranslate } from "@tolgee/react";
import { OrderItemPageActivityLogMessageActionTypeEnum } from "../../OrderItemPageActivityLogMessage.constants";
import { type OrderItemPageActivityLogWithFilesProps } from "./OrderItemPageActivityLogWithFiles.types";

export const OrderItemPageActivityLogWithFiles = ({
  intro,
  suffix,
  icon,
  iconLabel,
  iconState,
  file,
}: OrderItemPageActivityLogWithFilesProps) => {
  const { t } = useTranslate();

  const getInfoIconLabel = (iconLabel: string) => {
    switch (iconLabel) {
      case OrderItemPageActivityLogMessageActionTypeEnum.VALIDATED:
        return t(
          "order.myOrdersItemDetails.activityFeed.action.infoIcon.validated"
        );
      case OrderItemPageActivityLogMessageActionTypeEnum.REFUSED:
        return t(
          "order.myOrdersItemDetails.activityFeed.action.infoIcon.refused"
        );
      default:
        return "";
    }
  };

  return (
    <div className="flex items-center gap-sp-xs2">
      <KdsText>{intro}</KdsText>

      {file && (
        <KdsLink href={file?.url} target="_blank" size="sm">
          {file?.name}
        </KdsLink>
      )}

      <KdsText>{suffix}</KdsText>

      {iconLabel && (
        <KdsInfoIcon
          icon={icon || RiCheckboxCircleFill}
          state={iconState || "success"}
          label={getInfoIconLabel(iconLabel)}
        />
      )}
    </div>
  );
};
